module.exports = __webpack_public_path__ + "media/images/mandated-reporting-data-45aa6e25e5836922e7b3e9b28115a626.png";